import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initMonitoring } from './utils/monitoring';

// Design System Imports
import './styles/tokens.css';
import './styles/typography.css';
import './styles/components.css';
import './styles/utilities.css';
import './globals.css';

// Trap unhandled errors/promise rejections before React mounts (P1.8 seam).
initMonitoring();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
